{
 "source": "Energy+.idd",
 "iddVersion": "26.1.0",
 "generated": "2026-10-05",
 "objects": {
  "HVACTemplate:Thermostat": {
   "minFields": 5,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "reference": [
      "CompactHVACThermostats"
     ]
    },
    {
     "id": "A2",
     "name": "Heating Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N1",
     "name": "Constant Heating Setpoint",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "A3",
     "name": "Cooling Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N2",
     "name": "Constant Cooling Setpoint",
     "type": "numeric",
     "keys": [],
     "units": "C"
    }
   ]
  },
  "HVACTemplate:Zone:FanCoil": {
   "minFields": 34,
   "fields": [
    {
     "id": "A1",
     "name": "Zone Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A2",
     "name": "Template Thermostat Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "CompactHVACThermostats"
     ]
    },
    {
     "id": "N1",
     "name": "Supply Air Maximum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N2",
     "name": "Zone Heating Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N3",
     "name": "Zone Cooling Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A3",
     "name": "Outdoor Air Method",
     "type": "alpha",
     "keys": [
      "Flow/Person",
      "Flow/Zone",
      "Flow/Area",
      "Sum",
      "Maximum",
      "DetailedSpecification"
     ],
     "default": "Flow/Person"
    },
    {
     "id": "N4",
     "name": "Outdoor Air Flow Rate per Person",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.00944"
    },
    {
     "id": "N5",
     "name": "Outdoor Air Flow Rate per Zone Floor Area",
     "type": "numeric",
     "keys": [],
     "units": "m3/s-m2",
     "default": "0.0"
    },
    {
     "id": "N6",
     "name": "Outdoor Air Flow Rate per Zone",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.0"
    },
    {
     "id": "A4",
     "name": "System Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N7",
     "name": "Supply Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N8",
     "name": "Supply Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "75"
    },
    {
     "id": "N9",
     "name": "Supply Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N10",
     "name": "Supply Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    },
    {
     "id": "A5",
     "name": "Cooling Coil Type",
     "type": "alpha",
     "keys": [
      "ChilledWater",
      "ChilledWaterDetailedFlatModel",
      "HeatExchangerAssistedChilledWater"
     ],
     "default": "ChilledWater"
    },
    {
     "id": "A6",
     "name": "Cooling Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N11",
     "name": "Cooling Coil Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "14.0",
     "units": "C"
    },
    {
     "id": "A7",
     "name": "Heating Coil Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric"
     ],
     "default": "HotWater"
    },
    {
     "id": "A8",
     "name": "Heating Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N12",
     "name": "Heating Coil Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "50.0",
     "units": "C"
    },
    {
     "id": "A9",
     "name": "Dedicated Outdoor Air System Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "HVACTemplateDOASSystems"
     ]
    },
    {
     "id": "A10",
     "name": "Zone Cooling Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N13",
     "name": "Zone Cooling Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "11.11"
    },
    {
     "id": "A11",
     "name": "Zone Heating Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N14",
     "name": "Zone Heating Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "30.0"
    },
    {
     "id": "A12",
     "name": "Design Specification Outdoor Air Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationOutdoorAirNames",
      "DSOASpaceListNames"
     ]
    },
    {
     "id": "A13",
     "name": "Design Specification Zone Air Distribution Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationZoneAirDistributionNames"
     ]
    },
    {
     "id": "A14",
     "name": "Capacity Control Method",
     "type": "alpha",
     "keys": [
      "ConstantFanVariableFlow",
      "CyclingFan",
      "VariableFanVariableFlow",
      "VariableFanConstantFlow",
      "MultiSpeedFan",
      "ASHRAE90VariableFan"
     ]
    },
    {
     "id": "N15",
     "name": "Low Speed Supply Air Flow Ratio",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "default": "0.33"
    },
    {
     "id": "N16",
     "name": "Medium Speed Supply Air Flow Ratio",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "default": "0.66"
    },
    {
     "id": "A15",
     "name": "Outdoor Air Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A16",
     "name": "Baseboard Heating Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A17",
     "name": "Baseboard Heating Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N17",
     "name": "Baseboard Heating Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    }
   ]
  },
  "HVACTemplate:Zone:PTAC": {
   "minFields": 40,
   "fields": [
    {
     "id": "A1",
     "name": "Zone Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A2",
     "name": "Template Thermostat Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "CompactHVACThermostats"
     ]
    },
    {
     "id": "N1",
     "name": "Cooling Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N2",
     "name": "Heating Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N3",
     "name": "No Load Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "units": "m3/s"
    },
    {
     "id": "N4",
     "name": "Zone Heating Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N5",
     "name": "Zone Cooling Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A3",
     "name": "Outdoor Air Method",
     "type": "alpha",
     "keys": [
      "Flow/Person",
      "Flow/Zone",
      "Flow/Area",
      "Sum",
      "Maximum",
      "DetailedSpecification"
     ],
     "default": "Flow/Person"
    },
    {
     "id": "N6",
     "name": "Outdoor Air Flow Rate per Person",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.00944"
    },
    {
     "id": "N7",
     "name": "Outdoor Air Flow Rate per Zone Floor Area",
     "type": "numeric",
     "keys": [],
     "units": "m3/s-m2",
     "default": "0.0"
    },
    {
     "id": "N8",
     "name": "Outdoor Air Flow Rate per Zone",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.0"
    },
    {
     "id": "A4",
     "name": "System Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A5",
     "name": "Supply Fan Operating Mode Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A6",
     "name": "Supply Fan Placement",
     "type": "alpha",
     "keys": [
      "BlowThrough",
      "DrawThrough"
     ],
     "default": "DrawThrough"
    },
    {
     "id": "N9",
     "name": "Supply Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N10",
     "name": "Supply Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "75"
    },
    {
     "id": "N11",
     "name": "Supply Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "A7",
     "name": "Cooling Coil Type",
     "type": "alpha",
     "keys": [
      "SingleSpeedDX"
     ],
     "default": "SingleSpeedDX"
    },
    {
     "id": "A8",
     "name": "Cooling Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N12",
     "name": "Cooling Coil Gross Rated Total Capacity",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N13",
     "name": "Cooling Coil Gross Rated Sensible Heat Ratio",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "min": 0.5,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "autosize"
    },
    {
     "id": "N14",
     "name": "Cooling Coil Gross Rated Cooling COP",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 0,
     "minInclusive": false,
     "default": "3.0"
    },
    {
     "id": "A9",
     "name": "Heating Coil Type",
     "type": "alpha",
     "keys": [
      "Electric",
      "HotWater",
      "Gas"
     ],
     "default": "Electric"
    },
    {
     "id": "A10",
     "name": "Heating Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N15",
     "name": "Heating Coil Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N16",
     "name": "Gas Heating Coil Efficiency",
     "type": "numeric",
     "keys": [],
     "max": 1,
     "maxInclusive": true,
     "min": 0,
     "minInclusive": true,
     "default": "0.8"
    },
    {
     "id": "N17",
     "name": "Gas Heating Coil Parasitic Electric Load",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "A11",
     "name": "Dedicated Outdoor Air System Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "HVACTemplateDOASSystems"
     ]
    },
    {
     "id": "A12",
     "name": "Zone Cooling Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N18",
     "name": "Zone Cooling Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "14.0"
    },
    {
     "id": "N19",
     "name": "Zone Cooling Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "11.11"
    },
    {
     "id": "A13",
     "name": "Zone Heating Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N20",
     "name": "Zone Heating Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "50.0"
    },
    {
     "id": "N21",
     "name": "Zone Heating Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "30.0"
    },
    {
     "id": "A14",
     "name": "Design Specification Outdoor Air Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationOutdoorAirNames",
      "DSOASpaceListNames"
     ]
    },
    {
     "id": "A15",
     "name": "Design Specification Zone Air Distribution Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationZoneAirDistributionNames"
     ]
    },
    {
     "id": "A16",
     "name": "Baseboard Heating Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A17",
     "name": "Baseboard Heating Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N22",
     "name": "Baseboard Heating Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "A18",
     "name": "Capacity Control Method",
     "type": "alpha",
     "keys": [
      "None",
      "SingleZoneVAV"
     ],
     "default": "None"
    }
   ]
  },
  "HVACTemplate:Zone:PTHP": {
   "minFields": 50,
   "fields": [
    {
     "id": "A1",
     "name": "Zone Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A2",
     "name": "Template Thermostat Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "CompactHVACThermostats"
     ]
    },
    {
     "id": "N1",
     "name": "Cooling Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N2",
     "name": "Heating Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N3",
     "name": "No Load Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "units": "m3/s"
    },
    {
     "id": "N4",
     "name": "Zone Heating Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N5",
     "name": "Zone Cooling Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A3",
     "name": "Outdoor Air Method",
     "type": "alpha",
     "keys": [
      "Flow/Person",
      "Flow/Zone",
      "Flow/Area",
      "Sum",
      "Maximum",
      "DetailedSpecification"
     ],
     "default": "Flow/Person"
    },
    {
     "id": "N6",
     "name": "Outdoor Air Flow Rate per Person",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.00944"
    },
    {
     "id": "N7",
     "name": "Outdoor Air Flow Rate per Zone Floor Area",
     "type": "numeric",
     "keys": [],
     "units": "m3/s-m2",
     "default": "0.0"
    },
    {
     "id": "N8",
     "name": "Outdoor Air Flow Rate per Zone",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.0"
    },
    {
     "id": "A4",
     "name": "System Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A5",
     "name": "Supply Fan Operating Mode Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A6",
     "name": "Supply Fan Placement",
     "type": "alpha",
     "keys": [
      "BlowThrough",
      "DrawThrough"
     ],
     "default": "DrawThrough"
    },
    {
     "id": "N9",
     "name": "Supply Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N10",
     "name": "Supply Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "75"
    },
    {
     "id": "N11",
     "name": "Supply Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "A7",
     "name": "Cooling Coil Type",
     "type": "alpha",
     "keys": [
      "SingleSpeedDX"
     ],
     "default": "SingleSpeedDX"
    },
    {
     "id": "A8",
     "name": "Cooling Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N12",
     "name": "Cooling Coil Gross Rated Total Capacity",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N13",
     "name": "Cooling Coil Gross Rated Sensible Heat Ratio",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "min": 0.5,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "autosize"
    },
    {
     "id": "N14",
     "name": "Cooling Coil Gross Rated COP",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 0,
     "minInclusive": false,
     "default": "3.0"
    },
    {
     "id": "A9",
     "name": "Heat Pump Heating Coil Type",
     "type": "alpha",
     "keys": [
      "SingleSpeedDXHeatPump"
     ],
     "default": "SingleSpeedDXHeatPump"
    },
    {
     "id": "A10",
     "name": "Heat Pump Heating Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N15",
     "name": "Heat Pump Heating Coil Gross Rated Capacity",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N16",
     "name": "Heat Pump Heating Coil Gross Rated COP",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 0,
     "minInclusive": false,
     "default": "2.75"
    },
    {
     "id": "N17",
     "name": "Heat Pump Heating Minimum Outdoor Dry-Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "min": -20,
     "minInclusive": true,
     "default": "-8.0",
     "units": "C"
    },
    {
     "id": "N18",
     "name": "Heat Pump Defrost Maximum Outdoor Dry-Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 7.22,
     "maxInclusive": true,
     "default": "5.0",
     "units": "C"
    },
    {
     "id": "A11",
     "name": "Heat Pump Defrost Strategy",
     "type": "alpha",
     "keys": [
      "ReverseCycle",
      "Resistive"
     ],
     "default": "ReverseCycle"
    },
    {
     "id": "A12",
     "name": "Heat Pump Defrost Control",
     "type": "alpha",
     "keys": [
      "Timed",
      "OnDemand"
     ],
     "default": "Timed"
    },
    {
     "id": "N19",
     "name": "Heat Pump Defrost Time Period Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "default": "0.058333"
    },
    {
     "id": "A13",
     "name": "Supplemental Heating Coil Type",
     "type": "alpha",
     "keys": [
      "Electric",
      "Gas",
      "HotWater"
     ],
     "default": "Electric"
    },
    {
     "id": "A14",
     "name": "Supplemental Heating Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N20",
     "name": "Supplemental Heating Coil Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N21",
     "name": "Supplemental Heating Coil Maximum Outdoor Dry-Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "max": 21,
     "maxInclusive": true,
     "default": "21.0",
     "units": "C"
    },
    {
     "id": "N22",
     "name": "Supplemental Gas Heating Coil Efficiency",
     "type": "numeric",
     "keys": [],
     "max": 1,
     "maxInclusive": true,
     "min": 0,
     "minInclusive": true,
     "default": "0.8"
    },
    {
     "id": "N23",
     "name": "Supplemental Gas Heating Coil Parasitic Electric Load",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "A15",
     "name": "Dedicated Outdoor Air System Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "HVACTemplateDOASSystems"
     ]
    },
    {
     "id": "A16",
     "name": "Zone Cooling Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N24",
     "name": "Zone Cooling Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "14.0"
    },
    {
     "id": "N25",
     "name": "Zone Cooling Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "11.11"
    },
    {
     "id": "A17",
     "name": "Zone Heating Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N26",
     "name": "Zone Heating Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "50.0"
    },
    {
     "id": "N27",
     "name": "Zone Heating Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "30.0"
    },
    {
     "id": "A18",
     "name": "Design Specification Outdoor Air Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationOutdoorAirNames",
      "DSOASpaceListNames"
     ]
    },
    {
     "id": "A19",
     "name": "Design Specification Zone Air Distribution Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationZoneAirDistributionNames"
     ]
    },
    {
     "id": "A20",
     "name": "Baseboard Heating Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A21",
     "name": "Baseboard Heating Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N28",
     "name": "Baseboard Heating Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "A22",
     "name": "Capacity Control Method",
     "type": "alpha",
     "keys": [
      "None",
      "SingleZoneVAV"
     ],
     "default": "None"
    }
   ]
  },
  "HVACTemplate:Zone:VRF": {
   "minFields": 44,
   "fields": [
    {
     "id": "A1",
     "name": "Zone Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A2",
     "name": "Template VRF System Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "CompactHVACSystemVRF"
     ]
    },
    {
     "id": "A3",
     "name": "Template Thermostat Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "CompactHVACThermostats"
     ]
    },
    {
     "id": "N1",
     "name": "Zone Heating Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N2",
     "name": "Zone Cooling Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N3",
     "name": "Rated Total Heating Capacity Sizing Ratio",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 1,
     "minInclusive": true,
     "default": "1.0"
    },
    {
     "id": "N4",
     "name": "Cooling Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N5",
     "name": "No Cooling Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N6",
     "name": "Heating Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N7",
     "name": "No Heating Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N8",
     "name": "Cooling Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N9",
     "name": "Heating Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N10",
     "name": "No Load Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "A4",
     "name": "Outdoor Air Method",
     "type": "alpha",
     "keys": [
      "Flow/Person",
      "Flow/Zone",
      "Flow/Area",
      "Sum",
      "Maximum",
      "DetailedSpecification"
     ],
     "default": "Flow/Person"
    },
    {
     "id": "N11",
     "name": "Outdoor Air Flow Rate per Person",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.00944"
    },
    {
     "id": "N12",
     "name": "Outdoor Air Flow Rate per Zone Floor Area",
     "type": "numeric",
     "keys": [],
     "units": "m3/s-m2",
     "default": "0.0"
    },
    {
     "id": "N13",
     "name": "Outdoor Air Flow Rate per Zone",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.0"
    },
    {
     "id": "A5",
     "name": "Design Specification Outdoor Air Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationOutdoorAirNames",
      "DSOASpaceListNames"
     ]
    },
    {
     "id": "A6",
     "name": "Design Specification Zone Air Distribution Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationZoneAirDistributionNames"
     ]
    },
    {
     "id": "A7",
     "name": "System Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A8",
     "name": "Supply Fan Operating Mode Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A9",
     "name": "Supply Air Fan placement",
     "type": "alpha",
     "keys": [
      "BlowThrough",
      "DrawThrough"
     ],
     "default": "BlowThrough"
    },
    {
     "id": "N14",
     "name": "Supply Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N15",
     "name": "Supply Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "75"
    },
    {
     "id": "N16",
     "name": "Supply Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "A10",
     "name": "Cooling Coil Type",
     "type": "alpha",
     "keys": [
      "VariableRefrigerantFlowDX",
      "None"
     ],
     "default": "VariableRefrigerantFlowDX"
    },
    {
     "id": "A11",
     "name": "Cooling Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N17",
     "name": "Cooling Coil Gross Rated Total Capacity",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N18",
     "name": "Cooling Coil Gross Rated Sensible Heat Ratio",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "min": 0.5,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "autosize"
    },
    {
     "id": "A12",
     "name": "Heat Pump Heating Coil Type",
     "type": "alpha",
     "keys": [
      "VariableRefrigerantFlowDX",
      "None"
     ],
     "default": "VariableRefrigerantFlowDX"
    },
    {
     "id": "A13",
     "name": "Heat Pump Heating Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N19",
     "name": "Heat Pump Heating Coil Gross Rated Capacity",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N20",
     "name": "Zone Terminal Unit On Parasitic Electric Energy Use",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0"
    },
    {
     "id": "N21",
     "name": "Zone Terminal Unit Off Parasitic Electric Energy Use",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0"
    },
    {
     "id": "A14",
     "name": "Dedicated Outdoor Air System Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "HVACTemplateDOASSystems"
     ]
    },
    {
     "id": "A15",
     "name": "Zone Cooling Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N22",
     "name": "Zone Cooling Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "14.0"
    },
    {
     "id": "N23",
     "name": "Zone Cooling Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "11.11"
    },
    {
     "id": "A16",
     "name": "Zone Heating Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N24",
     "name": "Zone Heating Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "50.0"
    },
    {
     "id": "N25",
     "name": "Zone Heating Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "30.0"
    },
    {
     "id": "A17",
     "name": "Baseboard Heating Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A18",
     "name": "Baseboard Heating Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N26",
     "name": "Baseboard Heating Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    }
   ]
  },
  "HVACTemplate:Zone:Unitary": {
   "minFields": 21,
   "fields": [
    {
     "id": "A1",
     "name": "Zone Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A2",
     "name": "Template Unitary System Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "CompactHVACSystemUnitary"
     ]
    },
    {
     "id": "A3",
     "name": "Template Thermostat Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "CompactHVACThermostats"
     ]
    },
    {
     "id": "N1",
     "name": "Supply Air Maximum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N2",
     "name": "Zone Heating Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N3",
     "name": "Zone Cooling Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A4",
     "name": "Outdoor Air Method",
     "type": "alpha",
     "keys": [
      "Flow/Person",
      "Flow/Zone",
      "Flow/Area",
      "Sum",
      "Maximum",
      "DetailedSpecification"
     ],
     "default": "Flow/Person"
    },
    {
     "id": "N4",
     "name": "Outdoor Air Flow Rate per Person",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.00944"
    },
    {
     "id": "N5",
     "name": "Outdoor Air Flow Rate per Zone Floor Area",
     "type": "numeric",
     "keys": [],
     "units": "m3/s-m2",
     "default": "0.0"
    },
    {
     "id": "N6",
     "name": "Outdoor Air Flow Rate per Zone",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.0"
    },
    {
     "id": "A5",
     "name": "Supply Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A6",
     "name": "Return Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A7",
     "name": "Baseboard Heating Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A8",
     "name": "Baseboard Heating Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N7",
     "name": "Baseboard Heating Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "A9",
     "name": "Zone Cooling Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference",
      "SystemSupplyAirTemperature"
     ],
     "default": "SystemSupplyAirTemperature"
    },
    {
     "id": "N8",
     "name": "Zone Cooling Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.8"
    },
    {
     "id": "N9",
     "name": "Zone Cooling Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "11.11"
    },
    {
     "id": "A10",
     "name": "Zone Heating Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference",
      "SystemSupplyAirTemperature"
     ],
     "default": "SystemSupplyAirTemperature"
    },
    {
     "id": "N10",
     "name": "Zone Heating Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "50.0"
    },
    {
     "id": "N11",
     "name": "Zone Heating Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "30.0"
    },
    {
     "id": "A11",
     "name": "Design Specification Outdoor Air Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationOutdoorAirNames",
      "DSOASpaceListNames"
     ]
    },
    {
     "id": "A12",
     "name": "Design Specification Zone Air Distribution Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationZoneAirDistributionNames"
     ]
    }
   ]
  },
  "HVACTemplate:Zone:VAV": {
   "minFields": 32,
   "fields": [
    {
     "id": "A1",
     "name": "Zone Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A2",
     "name": "Template VAV System Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "CompactHVACSystemVAV"
     ]
    },
    {
     "id": "A3",
     "name": "Template Thermostat Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "CompactHVACThermostats"
     ]
    },
    {
     "id": "N1",
     "name": "Supply Air Maximum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N2",
     "name": "Zone Heating Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N3",
     "name": "Zone Cooling Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A4",
     "name": "Zone Minimum Air Flow Input Method",
     "type": "alpha",
     "keys": [
      "Constant",
      "FixedFlowRate",
      "Scheduled"
     ],
     "default": "Constant"
    },
    {
     "id": "N4",
     "name": "Constant Minimum Air Flow Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.2"
    },
    {
     "id": "N5",
     "name": "Fixed Minimum Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "units": "m3/s"
    },
    {
     "id": "A5",
     "name": "Minimum Air Flow Fraction Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A6",
     "name": "Outdoor Air Method",
     "type": "alpha",
     "keys": [
      "Flow/Person",
      "Flow/Zone",
      "Flow/Area",
      "Sum",
      "Maximum",
      "DetailedSpecification"
     ],
     "default": "Flow/Person"
    },
    {
     "id": "N6",
     "name": "Outdoor Air Flow Rate per Person",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.00944"
    },
    {
     "id": "N7",
     "name": "Outdoor Air Flow Rate per Zone Floor Area",
     "type": "numeric",
     "keys": [],
     "units": "m3/s-m2",
     "default": "0.0"
    },
    {
     "id": "N8",
     "name": "Outdoor Air Flow Rate per Zone",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.0"
    },
    {
     "id": "A7",
     "name": "Reheat Coil Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "Gas",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A8",
     "name": "Reheat Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A9",
     "name": "Damper Heating Action",
     "type": "alpha",
     "keys": [
      "Normal",
      "Reverse"
     ],
     "default": "Reverse"
    },
    {
     "id": "N9",
     "name": "Maximum Flow per Zone Floor Area During Reheat",
     "type": "numeric",
     "keys": [],
     "units": "m3/s-m2",
     "autocalculatable": true
    },
    {
     "id": "N10",
     "name": "Maximum Flow Fraction During Reheat",
     "type": "numeric",
     "keys": [],
     "autocalculatable": true
    },
    {
     "id": "N11",
     "name": "Maximum Reheat Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "A10",
     "name": "Design Specification Outdoor Air Object Name for Control",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationOutdoorAirNames",
      "DSOASpaceListNames"
     ]
    },
    {
     "id": "A11",
     "name": "Supply Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A12",
     "name": "Return Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A13",
     "name": "Baseboard Heating Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A14",
     "name": "Baseboard Heating Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N12",
     "name": "Baseboard Heating Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "A15",
     "name": "Zone Cooling Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference",
      "SystemSupplyAirTemperature"
     ],
     "default": "SystemSupplyAirTemperature"
    },
    {
     "id": "N13",
     "name": "Zone Cooling Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.8"
    },
    {
     "id": "N14",
     "name": "Zone Cooling Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "11.11"
    },
    {
     "id": "A16",
     "name": "Zone Heating Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N15",
     "name": "Zone Heating Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "50.0"
    },
    {
     "id": "N16",
     "name": "Zone Heating Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "30.0"
    },
    {
     "id": "A17",
     "name": "Design Specification Outdoor Air Object Name for Sizing",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationOutdoorAirNames",
      "DSOASpaceListNames"
     ]
    },
    {
     "id": "A18",
     "name": "Design Specification Zone Air Distribution Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationZoneAirDistributionNames"
     ]
    }
   ]
  },
  "HVACTemplate:Zone:VAV:FanPowered": {
   "minFields": 31,
   "fields": [
    {
     "id": "A1",
     "name": "Zone Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A2",
     "name": "Template VAV System Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "CompactHVACSystemVAV"
     ]
    },
    {
     "id": "A3",
     "name": "Template Thermostat Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "CompactHVACThermostats"
     ]
    },
    {
     "id": "N1",
     "name": "Primary Supply Air Maximum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N2",
     "name": "Zone Heating Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N3",
     "name": "Zone Cooling Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N4",
     "name": "Primary Supply Air Minimum Flow Fraction",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true
    },
    {
     "id": "N5",
     "name": "Secondary Supply Air Maximum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "A4",
     "name": "Flow Type",
     "type": "alpha",
     "keys": [
      "Series",
      "Parallel",
      "SeriesFromPlenum",
      "ParallelFromPlenum"
     ],
     "default": "Parallel"
    },
    {
     "id": "N6",
     "name": "Parallel Fan On Flow Fraction",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "A5",
     "name": "Outdoor Air Method",
     "type": "alpha",
     "keys": [
      "Flow/Person",
      "Flow/Zone",
      "Flow/Area",
      "Sum",
      "Maximum",
      "DetailedSpecification"
     ],
     "default": "Flow/Person"
    },
    {
     "id": "N7",
     "name": "Outdoor Air Flow Rate per Person",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.00944"
    },
    {
     "id": "N8",
     "name": "Outdoor Air Flow Rate per Zone Floor Area",
     "type": "numeric",
     "keys": [],
     "units": "m3/s-m2",
     "default": "0.0"
    },
    {
     "id": "N9",
     "name": "Outdoor Air Flow Rate per Zone",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.0"
    },
    {
     "id": "A6",
     "name": "Reheat Coil Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "Gas"
     ],
     "default": "Electric"
    },
    {
     "id": "A7",
     "name": "Reheat Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N10",
     "name": "Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N11",
     "name": "Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "1000"
    },
    {
     "id": "N12",
     "name": "Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "A8",
     "name": "Supply Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A9",
     "name": "Return Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A10",
     "name": "Baseboard Heating Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A11",
     "name": "Baseboard Heating Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N13",
     "name": "Baseboard Heating Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "A12",
     "name": "Zone Cooling Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference",
      "SystemSupplyAirTemperature"
     ],
     "default": "SystemSupplyAirTemperature"
    },
    {
     "id": "N14",
     "name": "Zone Cooling Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.8"
    },
    {
     "id": "N15",
     "name": "Zone Cooling Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "11.11"
    },
    {
     "id": "A13",
     "name": "Zone Heating Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N16",
     "name": "Zone Heating Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "50.0"
    },
    {
     "id": "N17",
     "name": "Zone Heating Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "30.0"
    },
    {
     "id": "A14",
     "name": "Zone PIU Fan Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A15",
     "name": "Design Specification Outdoor Air Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationOutdoorAirNames",
      "DSOASpaceListNames"
     ]
    },
    {
     "id": "A16",
     "name": "Design Specification Zone Air Distribution Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationZoneAirDistributionNames"
     ]
    }
   ]
  },
  "HVACTemplate:Zone:VAV:HeatAndCool": {
   "minFields": 27,
   "fields": [
    {
     "id": "A1",
     "name": "Zone Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A2",
     "name": "Template VAV System Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "CompactHVACSystemVAV"
     ]
    },
    {
     "id": "A3",
     "name": "Template Thermostat Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "CompactHVACThermostats"
     ]
    },
    {
     "id": "N1",
     "name": "Supply Air Maximum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N2",
     "name": "Zone Heating Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N3",
     "name": "Zone Cooling Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N4",
     "name": "Constant Minimum Air Flow Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.2"
    },
    {
     "id": "A4",
     "name": "Outdoor Air Method",
     "type": "alpha",
     "keys": [
      "Flow/Person",
      "Flow/Zone",
      "Flow/Area",
      "Sum",
      "Maximum",
      "DetailedSpecification"
     ],
     "default": "Flow/Person"
    },
    {
     "id": "N5",
     "name": "Outdoor Air Flow Rate per Person",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.00944"
    },
    {
     "id": "N6",
     "name": "Outdoor Air Flow Rate per Zone Floor Area",
     "type": "numeric",
     "keys": [],
     "units": "m3/s-m2",
     "default": "0.0"
    },
    {
     "id": "N7",
     "name": "Outdoor Air Flow Rate per Zone",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.0"
    },
    {
     "id": "A5",
     "name": "Design Specification Outdoor Air Object Name for Sizing",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationOutdoorAirNames",
      "DSOASpaceListNames"
     ]
    },
    {
     "id": "A6",
     "name": "Design Specification Zone Air Distribution Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationZoneAirDistributionNames"
     ]
    },
    {
     "id": "A7",
     "name": "Reheat Coil Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "Gas",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A8",
     "name": "Reheat Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N8",
     "name": "Maximum Reheat Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "A9",
     "name": "Supply Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A10",
     "name": "Return Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A11",
     "name": "Baseboard Heating Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A12",
     "name": "Baseboard Heating Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N9",
     "name": "Baseboard Heating Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "A13",
     "name": "Zone Cooling Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference",
      "SystemSupplyAirTemperature"
     ],
     "default": "SystemSupplyAirTemperature"
    },
    {
     "id": "N10",
     "name": "Zone Cooling Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.8"
    },
    {
     "id": "N11",
     "name": "Zone Cooling Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "11.11"
    },
    {
     "id": "A14",
     "name": "Zone Heating Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N12",
     "name": "Zone Heating Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "50.0"
    },
    {
     "id": "N13",
     "name": "Zone Heating Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "30.0"
    }
   ]
  },
  "HVACTemplate:Zone:ConstantVolume": {
   "minFields": 24,
   "fields": [
    {
     "id": "A1",
     "name": "Zone Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "ZoneNames"
     ],
     "reference": [
      "HVACTemplateConstantVolumeZones"
     ]
    },
    {
     "id": "A2",
     "name": "Template Constant Volume System Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "CompactHVACSystemConstantVolume"
     ]
    },
    {
     "id": "A3",
     "name": "Template Thermostat Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "CompactHVACThermostats"
     ]
    },
    {
     "id": "N1",
     "name": "Supply Air Maximum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N2",
     "name": "Zone Heating Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N3",
     "name": "Zone Cooling Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A4",
     "name": "Outdoor Air Method",
     "type": "alpha",
     "keys": [
      "Flow/Person",
      "Flow/Zone",
      "Flow/Area",
      "Sum",
      "Maximum",
      "DetailedSpecification"
     ],
     "default": "Flow/Person"
    },
    {
     "id": "N4",
     "name": "Outdoor Air Flow Rate per Person",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.00944"
    },
    {
     "id": "N5",
     "name": "Outdoor Air Flow Rate per Zone Floor Area",
     "type": "numeric",
     "keys": [],
     "units": "m3/s-m2",
     "default": "0.0"
    },
    {
     "id": "N6",
     "name": "Outdoor Air Flow Rate per Zone",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "default": "0.0"
    },
    {
     "id": "A5",
     "name": "Design Specification Outdoor Air Object name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationOutdoorAirNames",
      "DSOASpaceListNames"
     ]
    },
    {
     "id": "A6",
     "name": "Design Specification Zone Air Distribution Object Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "DesignSpecificationZoneAirDistributionNames"
     ]
    },
    {
     "id": "A7",
     "name": "Reheat Coil Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "Gas",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A8",
     "name": "Reheat Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N7",
     "name": "Maximum Reheat Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "A9",
     "name": "Supply Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A10",
     "name": "Return Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A11",
     "name": "Baseboard Heating Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A12",
     "name": "Baseboard Heating Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N8",
     "name": "Baseboard Heating Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "A13",
     "name": "Zone Cooling Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference",
      "SystemSupplyAirTemperature"
     ],
     "default": "SystemSupplyAirTemperature"
    },
    {
     "id": "N9",
     "name": "Zone Cooling Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.8"
    },
    {
     "id": "N10",
     "name": "Zone Cooling Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "11.11"
    },
    {
     "id": "A14",
     "name": "Zone Heating Design Supply Air Temperature Input Method",
     "type": "alpha",
     "keys": [
      "SupplyAirTemperature",
      "TemperatureDifference"
     ],
     "default": "SupplyAirTemperature"
    },
    {
     "id": "N11",
     "name": "Zone Heating Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "50.0"
    },
    {
     "id": "N12",
     "name": "Zone Heating Design Supply Air Temperature Difference",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "30.0"
    }
   ]
  },
  "HVACTemplate:System:VRF": {
   "minFields": 39,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "reference": [
      "CompactHVACSystemVRF",
      "HVACTemplateSystems"
     ]
    },
    {
     "id": "A2",
     "name": "System Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N1",
     "name": "Gross Rated Total Cooling Capacity",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N2",
     "name": "Gross Rated Cooling COP",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 0,
     "minInclusive": false,
     "default": "3.3"
    },
    {
     "id": "N3",
     "name": "Minimum Outdoor Temperature in Cooling Mode",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "-6.0"
    },
    {
     "id": "N4",
     "name": "Maximum Outdoor Temperature in Cooling Mode",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "43.0"
    },
    {
     "id": "N5",
     "name": "Gross Rated Heating Capacity",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N6",
     "name": "Rated Heating Capacity Sizing Ratio",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 1,
     "minInclusive": true,
     "default": "1.0"
    },
    {
     "id": "N7",
     "name": "Gross Rated Heating COP",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 0,
     "minInclusive": false,
     "default": "3.4"
    },
    {
     "id": "N8",
     "name": "Minimum Outdoor Temperature in Heating Mode",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "-20.0"
    },
    {
     "id": "N9",
     "name": "Maximum Outdoor Temperature in Heating Mode",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "16.0"
    },
    {
     "id": "N10",
     "name": "Minimum Heat Pump Part-Load Ratio",
     "type": "numeric",
     "keys": [],
     "units": "dimensionless",
     "default": "0.15"
    },
    {
     "id": "A3",
     "name": "Zone Name for Master Thermostat Location",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A4",
     "name": "Master Thermostat Priority Control Type",
     "type": "alpha",
     "keys": [
      "LoadPriority",
      "ZonePriority",
      "ThermostatOffsetPriority",
      "MasterThermostatPriority",
      "Scheduled"
     ],
     "default": "MasterThermostatPriority"
    },
    {
     "id": "A5",
     "name": "Thermostat Priority Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A6",
     "name": "Heat Pump Waste Heat Recovery",
     "type": "alpha",
     "keys": [
      "No",
      "Yes"
     ],
     "default": "No"
    },
    {
     "id": "N11",
     "name": "Equivalent Piping Length used for Piping Correction Factor in Cooling Mode",
     "type": "numeric",
     "keys": [],
     "units": "m",
     "default": "30.0"
    },
    {
     "id": "N12",
     "name": "Vertical Height used for Piping Correction Factor",
     "type": "numeric",
     "keys": [],
     "units": "m",
     "default": "10.0"
    },
    {
     "id": "N13",
     "name": "Equivalent Piping Length used for Piping Correction Factor in Heating Mode",
     "type": "numeric",
     "keys": [],
     "units": "m",
     "default": "30.0"
    },
    {
     "id": "N14",
     "name": "Crankcase Heater Power per Compressor",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "default": "33.0"
    },
    {
     "id": "N15",
     "name": "Number of Compressors",
     "type": "numeric",
     "keys": [],
     "units": "dimensionless",
     "default": "2"
    },
    {
     "id": "N16",
     "name": "Ratio of Compressor Size to Total Compressor Capacity",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "default": "0.5"
    },
    {
     "id": "N17",
     "name": "Maximum Outdoor Dry-bulb Temperature for Crankcase Heater",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "5.0"
    },
    {
     "id": "A7",
     "name": "Defrost Strategy",
     "type": "alpha",
     "keys": [
      "ReverseCycle",
      "Resistive"
     ],
     "default": "Resistive"
    },
    {
     "id": "A8",
     "name": "Defrost Control",
     "type": "alpha",
     "keys": [
      "Timed",
      "OnDemand"
     ],
     "default": "Timed"
    },
    {
     "id": "N18",
     "name": "Defrost Time Period Fraction",
     "type": "numeric",
     "keys": [],
     "units": "dimensionless",
     "min": 0,
     "minInclusive": true,
     "default": "0.058333"
    },
    {
     "id": "N19",
     "name": "Resistive Defrost Heater Capacity",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "autosize",
     "autosizable": true
    },
    {
     "id": "N20",
     "name": "Maximum Outdoor Dry-bulb Temperature for Defrost Operation",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "5.0"
    },
    {
     "id": "A9",
     "name": "Condenser Type",
     "type": "alpha",
     "keys": [
      "AirCooled",
      "EvaporativelyCooled",
      "WaterCooled"
     ],
     "default": "AirCooled"
    },
    {
     "id": "N21",
     "name": "Water Condenser Volume Flow Rate",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N22",
     "name": "Evaporative Condenser Effectiveness",
     "type": "numeric",
     "keys": [],
     "units": "dimensionless",
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N23",
     "name": "Evaporative Condenser Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N24",
     "name": "Evaporative Condenser Pump Rated Power Consumption",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0",
     "autosizable": true
    },
    {
     "id": "N25",
     "name": "Basin Heater Capacity",
     "type": "numeric",
     "keys": [],
     "units": "W/K",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "N26",
     "name": "Basin Heater Setpoint Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "min": 2,
     "minInclusive": true,
     "default": "2.0"
    },
    {
     "id": "A10",
     "name": "Basin Heater Operating Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A11",
     "name": "Fuel Type",
     "type": "alpha",
     "keys": [
      "Electricity",
      "NaturalGas",
      "Propane",
      "Diesel",
      "Gasoline",
      "FuelOilNo1",
      "FuelOilNo2",
      "OtherFuel1",
      "OtherFuel2"
     ],
     "default": "Electricity"
    },
    {
     "id": "N27",
     "name": "Minimum Outdoor Temperature in Heat Recovery Mode",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "-15"
    },
    {
     "id": "N28",
     "name": "Maximum Outdoor Temperature in Heat Recovery Mode",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "45"
    }
   ]
  },
  "HVACTemplate:System:Unitary": {
   "minFields": 51,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "reference": [
      "CompactHVACSystemUnitary",
      "HVACTemplateSystems"
     ]
    },
    {
     "id": "A2",
     "name": "System Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A3",
     "name": "Control Zone or Thermostat Location Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "N1",
     "name": "Supply Fan Maximum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "A4",
     "name": "Supply Fan Operating Mode Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N2",
     "name": "Supply Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N3",
     "name": "Supply Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "600"
    },
    {
     "id": "N4",
     "name": "Supply Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N5",
     "name": "Supply Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    },
    {
     "id": "A5",
     "name": "Cooling Coil Type",
     "type": "alpha",
     "keys": [
      "SingleSpeedDX",
      "None"
     ],
     "default": "SingleSpeedDX"
    },
    {
     "id": "A6",
     "name": "Cooling Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N6",
     "name": "Cooling Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "default": "12.8",
     "units": "C"
    },
    {
     "id": "N7",
     "name": "Cooling Coil Gross Rated Total Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N8",
     "name": "Cooling Coil Gross Rated Sensible Heat Ratio",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "min": 0.5,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "autosize"
    },
    {
     "id": "N9",
     "name": "Cooling Coil Gross Rated COP",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 0,
     "minInclusive": false,
     "default": "3.0"
    },
    {
     "id": "A7",
     "name": "Heating Coil Type",
     "type": "alpha",
     "keys": [
      "Electric",
      "Gas",
      "HotWater"
     ],
     "required": true
    },
    {
     "id": "A8",
     "name": "Heating Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N10",
     "name": "Heating Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "default": "50.0",
     "units": "C"
    },
    {
     "id": "N11",
     "name": "Heating Coil Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N12",
     "name": "Gas Heating Coil Efficiency",
     "type": "numeric",
     "keys": [],
     "max": 1,
     "maxInclusive": true,
     "min": 0,
     "minInclusive": true,
     "default": "0.8"
    },
    {
     "id": "N13",
     "name": "Gas Heating Coil Parasitic Electric Load",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "N14",
     "name": "Maximum Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N15",
     "name": "Minimum Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A9",
     "name": "Minimum Outdoor Air Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A10",
     "name": "Economizer Type",
     "type": "alpha",
     "keys": [
      "FixedDryBulb",
      "FixedEnthalpy",
      "DifferentialDryBulb",
      "DifferentialEnthalpy",
      "FixedDewPointAndDryBulb",
      "ElectronicEnthalpy",
      "DifferentialDryBulbAndEnthalpy",
      "NoEconomizer"
     ],
     "default": "NoEconomizer"
    },
    {
     "id": "A11",
     "name": "Economizer Lockout",
     "type": "alpha",
     "keys": [
      "NoLockout",
      "LockoutWithHeating",
      "LockoutWithCompressor"
     ],
     "default": "NoLockout"
    },
    {
     "id": "N16",
     "name": "Economizer Upper Temperature Limit",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "N17",
     "name": "Economizer Lower Temperature Limit",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "N18",
     "name": "Economizer Upper Enthalpy Limit",
     "type": "numeric",
     "keys": [],
     "units": "J/kg"
    },
    {
     "id": "N19",
     "name": "Economizer Maximum Limit Dewpoint Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "A12",
     "name": "Supply Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A13",
     "name": "Return Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A14",
     "name": "Supply Fan Placement",
     "type": "alpha",
     "keys": [
      "BlowThrough",
      "DrawThrough"
     ],
     "default": "BlowThrough"
    },
    {
     "id": "A15",
     "name": "Night Cycle Control",
     "type": "alpha",
     "keys": [
      "StayOff",
      "CycleOnAny",
      "CycleOnControlZone"
     ],
     "default": "StayOff"
    },
    {
     "id": "A16",
     "name": "Night Cycle Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A17",
     "name": "Heat Recovery Type",
     "type": "alpha",
     "keys": [
      "None",
      "Sensible",
      "Enthalpy"
     ],
     "default": "None"
    },
    {
     "id": "N20",
     "name": "Sensible Heat Recovery Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.70"
    },
    {
     "id": "N21",
     "name": "Latent Heat Recovery Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.65"
    },
    {
     "id": "A18",
     "name": "Dehumidification Control Type",
     "type": "alpha",
     "keys": [
      "None",
      "CoolReheatHeatingCoil",
      "CoolReheatDesuperheater"
     ],
     "default": "None"
    },
    {
     "id": "N22",
     "name": "Dehumidification Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 100,
     "maxInclusive": true,
     "default": "60.0",
     "units": "percent"
    },
    {
     "id": "A19",
     "name": "Humidifier Type",
     "type": "alpha",
     "keys": [
      "None",
      "ElectricSteam"
     ],
     "default": "None"
    },
    {
     "id": "A20",
     "name": "Humidifier Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N23",
     "name": "Humidifier Rated Capacity",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": true,
     "default": "0.000001"
    },
    {
     "id": "N24",
     "name": "Humidifier Rated Electric Power",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "A21",
     "name": "Humidifier Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "N25",
     "name": "Humidifier Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 100,
     "maxInclusive": true,
     "default": "30.0",
     "units": "percent"
    },
    {
     "id": "A22",
     "name": "Return Fan",
     "type": "alpha",
     "keys": [
      "Yes",
      "No"
     ],
     "default": "No"
    },
    {
     "id": "N26",
     "name": "Return Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N27",
     "name": "Return Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "500"
    },
    {
     "id": "N28",
     "name": "Return Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N29",
     "name": "Return Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    }
   ]
  },
  "HVACTemplate:System:UnitarySystem": {
   "minFields": 71,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "reference": [
      "CompactHVACSystemUnitary",
      "HVACTemplateSystems"
     ]
    },
    {
     "id": "A2",
     "name": "System Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A3",
     "name": "Control Type",
     "type": "alpha",
     "keys": [
      "Load",
      "SetPoint"
     ],
     "default": "Load"
    },
    {
     "id": "A4",
     "name": "Control Zone or Thermostat Location Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "N1",
     "name": "Cooling Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N2",
     "name": "Heating Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s"
    },
    {
     "id": "N3",
     "name": "No Load Supply Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "default": "autosize",
     "autosizable": true,
     "units": "m3/s"
    },
    {
     "id": "A5",
     "name": "Supply Fan Operating Mode Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A6",
     "name": "Supply Fan Placement",
     "type": "alpha",
     "keys": [
      "BlowThrough",
      "DrawThrough"
     ],
     "default": "BlowThrough"
    },
    {
     "id": "N4",
     "name": "Supply Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N5",
     "name": "Supply Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "600"
    },
    {
     "id": "N6",
     "name": "Supply Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N7",
     "name": "Supply Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    },
    {
     "id": "A7",
     "name": "Cooling Coil Type",
     "type": "alpha",
     "keys": [
      "SingleSpeedDX",
      "TwoSpeedDX",
      "MultiSpeedDX",
      "TwoStageDX",
      "TwoStageHumidityControlDX",
      "HeatExchangerAssistedDX",
      "SingleSpeedDXWaterCooled",
      "ChilledWater",
      "ChilledWaterDetailedFlatModel",
      "HeatExchangerAssistedChilledWater",
      "None"
     ],
     "default": "SingleSpeedDX"
    },
    {
     "id": "N8",
     "name": "Number of Speeds for Cooling",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 4,
     "maxInclusive": true,
     "default": "1"
    },
    {
     "id": "A8",
     "name": "Cooling Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N9",
     "name": "Cooling Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "default": "12.8",
     "units": "C"
    },
    {
     "id": "N10",
     "name": "DX Cooling Coil Gross Rated Total Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N11",
     "name": "DX Cooling Coil Gross Rated Sensible Heat Ratio",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "min": 0.5,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "autosize"
    },
    {
     "id": "N12",
     "name": "DX Cooling Coil Gross Rated COP",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 0,
     "minInclusive": false,
     "default": "3.0"
    },
    {
     "id": "A9",
     "name": "Heating Coil Type",
     "type": "alpha",
     "keys": [
      "Electric",
      "Gas",
      "HotWater",
      "SingleSpeedDXHeatPumpAirSource",
      "MultiSpeedDXHeatPumpAirSource",
      "SingleSpeedDXHeatPumpWaterSource",
      "MultiStageElectric",
      "MultiStageGas",
      "None"
     ],
     "default": "Gas"
    },
    {
     "id": "N13",
     "name": "Number of Speeds or Stages for Heating",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 4,
     "maxInclusive": true,
     "default": "1"
    },
    {
     "id": "A10",
     "name": "Heating Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N14",
     "name": "Heating Design Supply Air Temperature",
     "type": "numeric",
     "keys": [],
     "default": "50.0",
     "units": "C"
    },
    {
     "id": "N15",
     "name": "Heating Coil Gross Rated Capacity",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": false,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N16",
     "name": "Gas Heating Coil Efficiency",
     "type": "numeric",
     "keys": [],
     "max": 1,
     "maxInclusive": true,
     "min": 0,
     "minInclusive": true,
     "default": "0.8"
    },
    {
     "id": "N17",
     "name": "Gas Heating Coil Parasitic Electric Load",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "N18",
     "name": "Heat Pump Heating Coil Gross Rated COP",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 0,
     "minInclusive": false,
     "default": "2.75"
    },
    {
     "id": "N19",
     "name": "Heat Pump Heating Minimum Outdoor Dry-Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "min": -20,
     "minInclusive": true,
     "default": "-8.0",
     "units": "C"
    },
    {
     "id": "N20",
     "name": "Heat Pump Defrost Maximum Outdoor Dry-Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 7.22,
     "maxInclusive": true,
     "default": "5.0",
     "units": "C"
    },
    {
     "id": "A11",
     "name": "Heat Pump Defrost Strategy",
     "type": "alpha",
     "keys": [
      "ReverseCycle",
      "Resistive"
     ],
     "default": "ReverseCycle"
    },
    {
     "id": "A12",
     "name": "Heat Pump Defrost Control",
     "type": "alpha",
     "keys": [
      "Timed",
      "OnDemand"
     ],
     "default": "Timed"
    },
    {
     "id": "N21",
     "name": "Heat Pump Defrost Time Period Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "default": "0.058333"
    },
    {
     "id": "A13",
     "name": "Supplemental Heating or Reheat Coil Type",
     "type": "alpha",
     "keys": [
      "Electric",
      "Gas",
      "HotWater",
      "DesuperHeater",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A14",
     "name": "Supplemental Heating or Reheat Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N22",
     "name": "Supplemental Heating or Reheat Coil Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N23",
     "name": "Supplemental Heating or Reheat Coil Maximum Outdoor Dry-Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "max": 21,
     "maxInclusive": true,
     "default": "21.0",
     "units": "C"
    },
    {
     "id": "N24",
     "name": "Supplemental Gas Heating or Reheat Coil Efficiency",
     "type": "numeric",
     "keys": [],
     "max": 1,
     "maxInclusive": true,
     "min": 0,
     "minInclusive": true,
     "default": "0.8"
    },
    {
     "id": "N25",
     "name": "Supplemental Gas Heating or Reheat Coil Parasitic Electric Load",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "N26",
     "name": "Maximum Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N27",
     "name": "Minimum Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A15",
     "name": "Minimum Outdoor Air Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A16",
     "name": "Economizer Type",
     "type": "alpha",
     "keys": [
      "FixedDryBulb",
      "FixedEnthalpy",
      "DifferentialDryBulb",
      "DifferentialEnthalpy",
      "FixedDewPointAndDryBulb",
      "ElectronicEnthalpy",
      "DifferentialDryBulbAndEnthalpy",
      "NoEconomizer"
     ],
     "default": "NoEconomizer"
    },
    {
     "id": "A17",
     "name": "Economizer Lockout",
     "type": "alpha",
     "keys": [
      "NoLockout",
      "LockoutWithHeating",
      "LockoutWithCompressor"
     ],
     "default": "NoLockout"
    },
    {
     "id": "N28",
     "name": "Economizer Maximum Limit Dry-Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "N29",
     "name": "Economizer Maximum Limit Enthalpy",
     "type": "numeric",
     "keys": [],
     "units": "J/kg"
    },
    {
     "id": "N30",
     "name": "Economizer Maximum Limit Dewpoint Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "N31",
     "name": "Economizer Minimum Limit Dry-Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "A18",
     "name": "Supply Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A19",
     "name": "Return Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A20",
     "name": "Heat Recovery Type",
     "type": "alpha",
     "keys": [
      "None",
      "Sensible",
      "Enthalpy"
     ],
     "default": "None"
    },
    {
     "id": "N32",
     "name": "Sensible Heat Recovery Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.70"
    },
    {
     "id": "N33",
     "name": "Latent Heat Recovery Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.65"
    },
    {
     "id": "A21",
     "name": "Heat Recovery Heat Exchanger Type",
     "type": "alpha",
     "keys": [
      "Plate",
      "Rotary"
     ],
     "default": "Plate"
    },
    {
     "id": "A22",
     "name": "Heat Recovery Frost Control Type",
     "type": "alpha",
     "keys": [
      "None",
      "ExhaustAirRecirculation",
      "ExhaustOnly",
      "MinimumExhaustTemperature"
     ],
     "default": "None"
    },
    {
     "id": "A23",
     "name": "Dehumidification Control Type",
     "type": "alpha",
     "keys": [
      "None",
      "CoolReheat",
      "Multimode"
     ],
     "default": "None"
    },
    {
     "id": "N34",
     "name": "Dehumidification Relative Humidity Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 100,
     "maxInclusive": true,
     "default": "60.0",
     "units": "percent"
    },
    {
     "id": "A24",
     "name": "Dehumidification Relative Humidity Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A25",
     "name": "Humidifier Type",
     "type": "alpha",
     "keys": [
      "None",
      "ElectricSteam"
     ],
     "default": "None"
    },
    {
     "id": "A26",
     "name": "Humidifier Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N35",
     "name": "Humidifier Rated Capacity",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": true,
     "default": "0.000001"
    },
    {
     "id": "N36",
     "name": "Humidifier Rated Electric Power",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "A27",
     "name": "Humidifier Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "N37",
     "name": "Humidifier Relative Humidity Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 100,
     "maxInclusive": true,
     "default": "30.0",
     "units": "percent"
    },
    {
     "id": "A28",
     "name": "Humidifier Relative Humidity Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A29",
     "name": "Sizing Option",
     "type": "alpha",
     "keys": [
      "Coincident",
      "NonCoincident"
     ],
     "default": "NonCoincident"
    },
    {
     "id": "A30",
     "name": "Return Fan",
     "type": "alpha",
     "keys": [
      "Yes",
      "No"
     ],
     "default": "No"
    },
    {
     "id": "N38",
     "name": "Return Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N39",
     "name": "Return Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "300"
    },
    {
     "id": "N40",
     "name": "Return Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N41",
     "name": "Return Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    }
   ]
  },
  "HVACTemplate:System:VAV": {
   "minFields": 61,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "reference": [
      "CompactHVACSystemVAV",
      "HVACTemplateSystems"
     ]
    },
    {
     "id": "A2",
     "name": "System Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N1",
     "name": "Supply Fan Maximum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "N2",
     "name": "Supply Fan Minimum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N3",
     "name": "Supply Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N4",
     "name": "Supply Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "1000"
    },
    {
     "id": "N5",
     "name": "Supply Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N6",
     "name": "Supply Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    },
    {
     "id": "A3",
     "name": "Cooling Coil Type",
     "type": "alpha",
     "keys": [
      "ChilledWater",
      "ChilledWaterDetailedFlatModel"
     ],
     "default": "ChilledWater"
    },
    {
     "id": "A4",
     "name": "Cooling Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A5",
     "name": "Cooling Coil Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N7",
     "name": "Cooling Coil Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "12.8",
     "units": "C"
    },
    {
     "id": "A6",
     "name": "Heating Coil Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "Gas",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A7",
     "name": "Heating Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A8",
     "name": "Heating Coil Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N8",
     "name": "Heating Coil Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "10.0",
     "units": "C"
    },
    {
     "id": "N9",
     "name": "Gas Heating Coil Efficiency",
     "type": "numeric",
     "keys": [],
     "max": 1,
     "maxInclusive": true,
     "min": 0,
     "minInclusive": true,
     "default": "0.8"
    },
    {
     "id": "N10",
     "name": "Gas Heating Coil Parasitic Electric Load",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "A9",
     "name": "Preheat Coil Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "Gas",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A10",
     "name": "Preheat Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A11",
     "name": "Preheat Coil Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N11",
     "name": "Preheat Coil Design Setpoint",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "7.2"
    },
    {
     "id": "N12",
     "name": "Gas Preheat Coil Efficiency",
     "type": "numeric",
     "keys": [],
     "max": 1,
     "maxInclusive": true,
     "min": 0,
     "minInclusive": true,
     "default": "0.8"
    },
    {
     "id": "N13",
     "name": "Gas Preheat Coil Parasitic Electric Load",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "N14",
     "name": "Maximum Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N15",
     "name": "Minimum Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A12",
     "name": "Minimum Outdoor Air Control Type",
     "type": "alpha",
     "keys": [
      "FixedMinimum",
      "ProportionalMinimum"
     ],
     "default": "ProportionalMinimum"
    },
    {
     "id": "A13",
     "name": "Minimum Outdoor Air Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A14",
     "name": "Economizer Type",
     "type": "alpha",
     "keys": [
      "FixedDryBulb",
      "FixedEnthalpy",
      "DifferentialDryBulb",
      "DifferentialEnthalpy",
      "FixedDewPointAndDryBulb",
      "ElectronicEnthalpy",
      "DifferentialDryBulbAndEnthalpy",
      "NoEconomizer"
     ],
     "default": "NoEconomizer"
    },
    {
     "id": "A15",
     "name": "Economizer Lockout",
     "type": "alpha",
     "keys": [
      "NoLockout"
     ],
     "default": "NoLockout"
    },
    {
     "id": "N16",
     "name": "Economizer Upper Temperature Limit",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "N17",
     "name": "Economizer Lower Temperature Limit",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "N18",
     "name": "Economizer Upper Enthalpy Limit",
     "type": "numeric",
     "keys": [],
     "units": "J/kg"
    },
    {
     "id": "N19",
     "name": "Economizer Maximum Limit Dewpoint Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "A16",
     "name": "Supply Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A17",
     "name": "Return Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A18",
     "name": "Supply Fan Placement",
     "type": "alpha",
     "keys": [
      "DrawThrough",
      "BlowThrough"
     ],
     "default": "DrawThrough"
    },
    {
     "id": "A19",
     "name": "Supply Fan Part-Load Power Coefficients",
     "type": "alpha",
     "keys": [
      "InletVaneDampers",
      "OutletDampers",
      "VariableSpeedMotor",
      "ASHRAE90.1-2004AppendixG",
      "VariableSpeedMotorPressureReset"
     ],
     "default": "InletVaneDampers"
    },
    {
     "id": "A20",
     "name": "Night Cycle Control",
     "type": "alpha",
     "keys": [
      "StayOff",
      "CycleOnAny",
      "CycleOnControlZone",
      "CycleOnAnyZoneFansOnly"
     ],
     "default": "StayOff"
    },
    {
     "id": "A21",
     "name": "Night Cycle Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A22",
     "name": "Heat Recovery Type",
     "type": "alpha",
     "keys": [
      "None",
      "Sensible",
      "Enthalpy"
     ],
     "default": "None"
    },
    {
     "id": "N20",
     "name": "Sensible Heat Recovery Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.70"
    },
    {
     "id": "N21",
     "name": "Latent Heat Recovery Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.65"
    },
    {
     "id": "A23",
     "name": "Cooling Coil Setpoint Reset Type",
     "type": "alpha",
     "keys": [
      "None",
      "Warmest",
      "OutdoorAirTemperatureReset",
      "WarmestTemperatureFirst"
     ],
     "default": "None"
    },
    {
     "id": "A24",
     "name": "Heating Coil Setpoint Reset Type",
     "type": "alpha",
     "keys": [
      "None",
      "OutdoorAirTemperatureReset"
     ],
     "default": "None"
    },
    {
     "id": "A25",
     "name": "Dehumidification Control Type",
     "type": "alpha",
     "keys": [
      "None",
      "CoolReheat"
     ],
     "default": "None"
    },
    {
     "id": "A26",
     "name": "Dehumidification Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "N22",
     "name": "Dehumidification Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 100,
     "maxInclusive": true,
     "default": "60.0",
     "units": "percent"
    },
    {
     "id": "A27",
     "name": "Humidifier Type",
     "type": "alpha",
     "keys": [
      "None",
      "ElectricSteam"
     ],
     "default": "None"
    },
    {
     "id": "A28",
     "name": "Humidifier Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N23",
     "name": "Humidifier Rated Capacity",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": true,
     "default": "0.000001"
    },
    {
     "id": "N24",
     "name": "Humidifier Rated Electric Power",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "A29",
     "name": "Humidifier Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "N25",
     "name": "Humidifier Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 100,
     "maxInclusive": true,
     "default": "30.0",
     "units": "percent"
    },
    {
     "id": "A30",
     "name": "Sizing Option",
     "type": "alpha",
     "keys": [
      "Coincident",
      "NonCoincident"
     ],
     "default": "NonCoincident"
    },
    {
     "id": "A31",
     "name": "Return Fan",
     "type": "alpha",
     "keys": [
      "Yes",
      "No"
     ],
     "default": "No"
    },
    {
     "id": "N26",
     "name": "Return Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N27",
     "name": "Return Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "500"
    },
    {
     "id": "N28",
     "name": "Return Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N29",
     "name": "Return Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    },
    {
     "id": "A32",
     "name": "Return Fan Part-Load Power Coefficients",
     "type": "alpha",
     "keys": [
      "InletVaneDampers",
      "OutletDampers",
      "VariableSpeedMotor",
      "ASHRAE90.1-2004AppendixG",
      "VariableSpeedMotorPressureReset"
     ],
     "default": "InletVaneDampers"
    }
   ]
  },
  "HVACTemplate:System:PackagedVAV": {
   "minFields": 59,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "reference": [
      "CompactHVACSystemVAV",
      "HVACTemplateSystems"
     ]
    },
    {
     "id": "A2",
     "name": "System Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N1",
     "name": "Supply Fan Maximum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "N2",
     "name": "Supply Fan Minimum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A3",
     "name": "Supply Fan Placement",
     "type": "alpha",
     "keys": [
      "DrawThrough",
      "BlowThrough"
     ],
     "default": "DrawThrough"
    },
    {
     "id": "N3",
     "name": "Supply Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N4",
     "name": "Supply Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "1000"
    },
    {
     "id": "N5",
     "name": "Supply Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N6",
     "name": "Supply Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    },
    {
     "id": "A4",
     "name": "Cooling Coil Type",
     "type": "alpha",
     "keys": [
      "TwoSpeedDX",
      "TwoSpeedHumidControlDX"
     ],
     "default": "TwoSpeedDX"
    },
    {
     "id": "A5",
     "name": "Cooling Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A6",
     "name": "Cooling Coil Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N7",
     "name": "Cooling Coil Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "12.8",
     "units": "C"
    },
    {
     "id": "N8",
     "name": "Cooling Coil Gross Rated Total Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N9",
     "name": "Cooling Coil Gross Rated Sensible Heat Ratio",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "min": 0.5,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "autosize"
    },
    {
     "id": "N10",
     "name": "Cooling Coil Gross Rated COP",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 0,
     "minInclusive": false,
     "default": "3.0"
    },
    {
     "id": "A7",
     "name": "Heating Coil Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "Gas",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A8",
     "name": "Heating Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A9",
     "name": "Heating Coil Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N11",
     "name": "Heating Coil Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "10.0",
     "units": "C"
    },
    {
     "id": "N12",
     "name": "Heating Coil Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N13",
     "name": "Gas Heating Coil Efficiency",
     "type": "numeric",
     "keys": [],
     "max": 1,
     "maxInclusive": true,
     "min": 0,
     "minInclusive": true,
     "default": "0.8"
    },
    {
     "id": "N14",
     "name": "Gas Heating Coil Parasitic Electric Load",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "N15",
     "name": "Maximum Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N16",
     "name": "Minimum Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A10",
     "name": "Minimum Outdoor Air Control Type",
     "type": "alpha",
     "keys": [
      "FixedMinimum",
      "ProportionalMinimum"
     ],
     "default": "ProportionalMinimum"
    },
    {
     "id": "A11",
     "name": "Minimum Outdoor Air Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A12",
     "name": "Economizer Type",
     "type": "alpha",
     "keys": [
      "FixedDryBulb",
      "FixedEnthalpy",
      "DifferentialDryBulb",
      "DifferentialEnthalpy",
      "FixedDewPointAndDryBulb",
      "ElectronicEnthalpy",
      "DifferentialDryBulbAndEnthalpy",
      "NoEconomizer"
     ],
     "default": "NoEconomizer"
    },
    {
     "id": "A13",
     "name": "Economizer Lockout",
     "type": "alpha",
     "keys": [
      "NoLockout",
      "LockoutWithHeating",
      "LockoutWithCompressor"
     ],
     "default": "NoLockout"
    },
    {
     "id": "N17",
     "name": "Economizer Maximum Limit Dry-Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "N18",
     "name": "Economizer Maximum Limit Enthalpy",
     "type": "numeric",
     "keys": [],
     "units": "J/kg"
    },
    {
     "id": "N19",
     "name": "Economizer Maximum Limit Dewpoint Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "N20",
     "name": "Economizer Minimum Limit Dry-Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "A14",
     "name": "Supply Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A15",
     "name": "Return Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A16",
     "name": "Supply Fan Part-Load Power Coefficients",
     "type": "alpha",
     "keys": [
      "InletVaneDampers",
      "OutletDampers",
      "VariableSpeedMotor",
      "ASHRAE90.1-2004AppendixG",
      "VariableSpeedMotorPressureReset"
     ],
     "default": "InletVaneDampers"
    },
    {
     "id": "A17",
     "name": "Night Cycle Control",
     "type": "alpha",
     "keys": [
      "StayOff",
      "CycleOnAny",
      "CycleOnControlZone",
      "CycleOnAnyZoneFansOnly"
     ],
     "default": "StayOff"
    },
    {
     "id": "A18",
     "name": "Night Cycle Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A19",
     "name": "Heat Recovery Type",
     "type": "alpha",
     "keys": [
      "None",
      "Sensible",
      "Enthalpy"
     ],
     "default": "None"
    },
    {
     "id": "N21",
     "name": "Sensible Heat Recovery Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.70"
    },
    {
     "id": "N22",
     "name": "Latent Heat Recovery Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.65"
    },
    {
     "id": "A20",
     "name": "Cooling Coil Setpoint Reset Type",
     "type": "alpha",
     "keys": [
      "None",
      "Warmest",
      "OutdoorAirTemperatureReset",
      "WarmestTemperatureFirst"
     ],
     "default": "None"
    },
    {
     "id": "A21",
     "name": "Heating Coil Setpoint Reset Type",
     "type": "alpha",
     "keys": [
      "None",
      "OutdoorAirTemperatureReset"
     ],
     "default": "None"
    },
    {
     "id": "A22",
     "name": "Dehumidification Control Type",
     "type": "alpha",
     "keys": [
      "None",
      "CoolReheat"
     ],
     "default": "None"
    },
    {
     "id": "A23",
     "name": "Dehumidification Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "N23",
     "name": "Dehumidification Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 100,
     "maxInclusive": true,
     "default": "60.0",
     "units": "percent"
    },
    {
     "id": "A24",
     "name": "Humidifier Type",
     "type": "alpha",
     "keys": [
      "None",
      "ElectricSteam"
     ],
     "default": "None"
    },
    {
     "id": "A25",
     "name": "Humidifier Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N24",
     "name": "Humidifier Rated Capacity",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": true,
     "default": "0.000001"
    },
    {
     "id": "N25",
     "name": "Humidifier Rated Electric Power",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "A26",
     "name": "Humidifier Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "N26",
     "name": "Humidifier Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 100,
     "maxInclusive": true,
     "default": "30.0",
     "units": "percent"
    },
    {
     "id": "A27",
     "name": "Sizing Option",
     "type": "alpha",
     "keys": [
      "Coincident",
      "NonCoincident"
     ],
     "default": "NonCoincident"
    },
    {
     "id": "A28",
     "name": "Return Fan",
     "type": "alpha",
     "keys": [
      "Yes",
      "No"
     ],
     "default": "No"
    },
    {
     "id": "N27",
     "name": "Return Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N28",
     "name": "Return Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "500"
    },
    {
     "id": "N29",
     "name": "Return Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N30",
     "name": "Return Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    },
    {
     "id": "A29",
     "name": "Return Fan Part-Load Power Coefficients",
     "type": "alpha",
     "keys": [
      "InletVaneDampers",
      "OutletDampers",
      "VariableSpeedMotor",
      "ASHRAE90.1-2004AppendixG",
      "VariableSpeedMotorPressureReset"
     ],
     "default": "InletVaneDampers"
    }
   ]
  },
  "HVACTemplate:System:ConstantVolume": {
   "minFields": 70,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true,
     "reference": [
      "CompactHVACSystemConstantVolume",
      "HVACTemplateSystems"
     ]
    },
    {
     "id": "A2",
     "name": "System Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N1",
     "name": "Supply Fan Maximum Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "N2",
     "name": "Supply Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N3",
     "name": "Supply Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "600"
    },
    {
     "id": "N4",
     "name": "Supply Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N5",
     "name": "Supply Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    },
    {
     "id": "A3",
     "name": "Supply Fan Placement",
     "type": "alpha",
     "keys": [
      "DrawThrough",
      "BlowThrough"
     ],
     "default": "DrawThrough"
    },
    {
     "id": "A4",
     "name": "Cooling Coil Type",
     "type": "alpha",
     "keys": [
      "ChilledWater",
      "ChilledWaterDetailedFlatModel",
      "HeatExchangerAssistedChilledWater",
      "None"
     ],
     "default": "ChilledWater"
    },
    {
     "id": "A5",
     "name": "Cooling Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A6",
     "name": "Cooling Coil Setpoint Control Type",
     "type": "alpha",
     "keys": [
      "FixedSetpoint",
      "Scheduled",
      "OutdoorAirTemperatureReset",
      "Warmest",
      "ControlZone"
     ],
     "default": "FixedSetpoint"
    },
    {
     "id": "A7",
     "name": "Cooling Coil Control Zone name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "HVACTemplateConstantVolumeZones"
     ]
    },
    {
     "id": "N6",
     "name": "Cooling Coil Design Setpoint Temperature",
     "type": "numeric",
     "keys": [],
     "default": "12.8",
     "units": "C"
    },
    {
     "id": "A8",
     "name": "Cooling Coil Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N7",
     "name": "Cooling Coil Setpoint at Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "15.6"
    },
    {
     "id": "N8",
     "name": "Cooling Coil Reset Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "15.6"
    },
    {
     "id": "N9",
     "name": "Cooling Coil Setpoint at Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.8"
    },
    {
     "id": "N10",
     "name": "Cooling Coil Reset Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "23.3"
    },
    {
     "id": "A9",
     "name": "Heating Coil Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "Gas",
      "None"
     ],
     "default": "HotWater"
    },
    {
     "id": "A10",
     "name": "Heating Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A11",
     "name": "Heating Coil Setpoint Control Type",
     "type": "alpha",
     "keys": [
      "FixedSetpoint",
      "Scheduled",
      "OutdoorAirTemperatureReset",
      "ControlZone"
     ],
     "default": "FixedSetpoint"
    },
    {
     "id": "A12",
     "name": "Heating Coil Control Zone name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "HVACTemplateConstantVolumeZones"
     ]
    },
    {
     "id": "N11",
     "name": "Heating Coil Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "10.0",
     "units": "C"
    },
    {
     "id": "A13",
     "name": "Heating Coil Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N12",
     "name": "Heating Coil Setpoint at Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "15.0"
    },
    {
     "id": "N13",
     "name": "Heating Coil Reset Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "7.8"
    },
    {
     "id": "N14",
     "name": "Heating Coil Setpoint at Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.2"
    },
    {
     "id": "N15",
     "name": "Heating Coil Reset Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.2"
    },
    {
     "id": "N16",
     "name": "Heating Coil Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N17",
     "name": "Gas Heating Coil Efficiency",
     "type": "numeric",
     "keys": [],
     "max": 1,
     "maxInclusive": true,
     "min": 0,
     "minInclusive": true,
     "default": "0.8"
    },
    {
     "id": "N18",
     "name": "Gas Heating Coil Parasitic Electric Load",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "A14",
     "name": "Preheat Coil Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "Gas",
      "None"
     ],
     "default": "None"
    },
    {
     "id": "A15",
     "name": "Preheat Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N19",
     "name": "Preheat Coil Design Setpoint",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "7.2"
    },
    {
     "id": "A16",
     "name": "Preheat Coil Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N20",
     "name": "Gas Preheat Coil Efficiency",
     "type": "numeric",
     "keys": [],
     "max": 1,
     "maxInclusive": true,
     "min": 0,
     "minInclusive": true,
     "default": "0.8"
    },
    {
     "id": "N21",
     "name": "Gas Preheat Coil Parasitic Electric Load",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "N22",
     "name": "Maximum Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "N23",
     "name": "Minimum Outdoor Air Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A17",
     "name": "Minimum Outdoor Air Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A18",
     "name": "Economizer Type",
     "type": "alpha",
     "keys": [
      "FixedDryBulb",
      "FixedEnthalpy",
      "DifferentialDryBulb",
      "DifferentialEnthalpy",
      "FixedDewPointAndDryBulb",
      "ElectronicEnthalpy",
      "DifferentialDryBulbAndEnthalpy",
      "NoEconomizer"
     ],
     "default": "NoEconomizer"
    },
    {
     "id": "N24",
     "name": "Economizer Upper Temperature Limit",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "N25",
     "name": "Economizer Lower Temperature Limit",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "N26",
     "name": "Economizer Upper Enthalpy Limit",
     "type": "numeric",
     "keys": [],
     "units": "J/kg"
    },
    {
     "id": "N27",
     "name": "Economizer Maximum Limit Dewpoint Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "A19",
     "name": "Supply Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A20",
     "name": "Return Plenum Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A21",
     "name": "Night Cycle Control",
     "type": "alpha",
     "keys": [
      "StayOff",
      "CycleOnAny",
      "CycleOnControlZone",
      "CycleOnAnyZoneFansOnly"
     ],
     "default": "StayOff"
    },
    {
     "id": "A22",
     "name": "Night Cycle Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "A23",
     "name": "Heat Recovery Type",
     "type": "alpha",
     "keys": [
      "None",
      "Sensible",
      "Enthalpy"
     ],
     "default": "None"
    },
    {
     "id": "N28",
     "name": "Sensible Heat Recovery Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.70"
    },
    {
     "id": "N29",
     "name": "Latent Heat Recovery Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.65"
    },
    {
     "id": "A24",
     "name": "Heat Recovery Heat Exchanger Type",
     "type": "alpha",
     "keys": [
      "Plate",
      "Rotary"
     ],
     "default": "Plate"
    },
    {
     "id": "A25",
     "name": "Heat Recovery Frost Control Type",
     "type": "alpha",
     "keys": [
      "None",
      "ExhaustAirRecirculation",
      "ExhaustOnly",
      "MinimumExhaustTemperature"
     ],
     "default": "None"
    },
    {
     "id": "A26",
     "name": "Dehumidification Control Type",
     "type": "alpha",
     "keys": [
      "None",
      "CoolReheat"
     ],
     "default": "None"
    },
    {
     "id": "A27",
     "name": "Dehumidification Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "N30",
     "name": "Dehumidification Relative Humidity Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 100,
     "maxInclusive": true,
     "default": "60.0",
     "units": "percent"
    },
    {
     "id": "A28",
     "name": "Dehumidification Relative Humidity Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A29",
     "name": "Humidifier Type",
     "type": "alpha",
     "keys": [
      "None",
      "ElectricSteam"
     ],
     "default": "None"
    },
    {
     "id": "A30",
     "name": "Humidifier Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N31",
     "name": "Humidifier Rated Capacity",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": true,
     "default": "0.000001"
    },
    {
     "id": "N32",
     "name": "Humidifier Rated Electric Power",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "A31",
     "name": "Humidifier Control Zone Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ZoneNames"
     ]
    },
    {
     "id": "N33",
     "name": "Humidifier Relative Humidity Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 100,
     "maxInclusive": true,
     "default": "30.0",
     "units": "percent"
    },
    {
     "id": "A32",
     "name": "Humidifier Relative Humidity Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A33",
     "name": "Return Fan",
     "type": "alpha",
     "keys": [
      "Yes",
      "No"
     ],
     "default": "No"
    },
    {
     "id": "N34",
     "name": "Return Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N35",
     "name": "Return Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "300"
    },
    {
     "id": "N36",
     "name": "Return Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N37",
     "name": "Return Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    }
   ]
  },
  "HVACTemplate:System:DedicatedOutdoorAir": {
   "minFields": 46,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "reference": [
      "HVACTemplateDOASSystems",
      "HVACTemplateSystems"
     ]
    },
    {
     "id": "A2",
     "name": "System Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A3",
     "name": "Air Outlet Type",
     "type": "alpha",
     "keys": [
      "DirectIntoZone"
     ],
     "default": "DirectIntoZone"
    },
    {
     "id": "N1",
     "name": "Supply Fan Flow Rate",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "m3/s",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "N2",
     "name": "Supply Fan Total Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.7"
    },
    {
     "id": "N3",
     "name": "Supply Fan Delta Pressure",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "1000"
    },
    {
     "id": "N4",
     "name": "Supply Fan Motor Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "max": 1,
     "maxInclusive": true,
     "default": "0.9"
    },
    {
     "id": "N5",
     "name": "Supply Fan Motor in Air Stream Fraction",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "1.0"
    },
    {
     "id": "A4",
     "name": "Supply Fan Placement",
     "type": "alpha",
     "keys": [
      "DrawThrough",
      "BlowThrough"
     ],
     "default": "DrawThrough"
    },
    {
     "id": "A5",
     "name": "Cooling Coil Type",
     "type": "alpha",
     "keys": [
      "ChilledWater",
      "ChilledWaterDetailedFlatModel",
      "TwoSpeedDX",
      "TwoStageDX",
      "TwoStageHumidityControlDX",
      "HeatExchangerAssistedChilledWater",
      "HeatExchangerAssistedDX",
      "None"
     ],
     "default": "ChilledWater"
    },
    {
     "id": "A6",
     "name": "Cooling Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A7",
     "name": "Cooling Coil Setpoint Control Type",
     "type": "alpha",
     "keys": [
      "FixedSetpoint",
      "Scheduled",
      "OutdoorAirTemperatureReset"
     ],
     "default": "FixedSetpoint"
    },
    {
     "id": "N6",
     "name": "Cooling Coil Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "12.8",
     "units": "C"
    },
    {
     "id": "A8",
     "name": "Cooling Coil Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N7",
     "name": "Cooling Coil Setpoint at Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "15.6"
    },
    {
     "id": "N8",
     "name": "Cooling Coil Reset Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "15.6"
    },
    {
     "id": "N9",
     "name": "Cooling Coil Setpoint at Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.8"
    },
    {
     "id": "N10",
     "name": "Cooling Coil Reset Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "23.3"
    },
    {
     "id": "N11",
     "name": "DX Cooling Coil Gross Rated Total Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W"
    },
    {
     "id": "N12",
     "name": "DX Cooling Coil Gross Rated Sensible Heat Ratio",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "min": 0.5,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "autosize"
    },
    {
     "id": "N13",
     "name": "DX Cooling Coil Gross Rated COP",
     "type": "numeric",
     "keys": [],
     "units": "W/W",
     "min": 0,
     "minInclusive": false,
     "default": "3.0"
    },
    {
     "id": "A9",
     "name": "Heating Coil Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "Electric",
      "Gas",
      "None"
     ],
     "default": "HotWater"
    },
    {
     "id": "A10",
     "name": "Heating Coil Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A11",
     "name": "Heating Coil Setpoint Control Type",
     "type": "alpha",
     "keys": [
      "FixedSetpoint",
      "Scheduled",
      "OutdoorAirTemperatureReset"
     ],
     "default": "FixedSetpoint"
    },
    {
     "id": "N14",
     "name": "Heating Coil Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "12.2",
     "units": "C"
    },
    {
     "id": "A12",
     "name": "Heating Coil Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N15",
     "name": "Heating Coil Setpoint at Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "15.0"
    },
    {
     "id": "N16",
     "name": "Heating Coil Reset Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "7.8"
    },
    {
     "id": "N17",
     "name": "Heating Coil Setpoint at Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.2"
    },
    {
     "id": "N18",
     "name": "Heating Coil Reset Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.2"
    },
    {
     "id": "N19",
     "name": "Gas Heating Coil Efficiency",
     "type": "numeric",
     "keys": [],
     "max": 1,
     "maxInclusive": true,
     "min": 0,
     "minInclusive": true,
     "default": "0.8"
    },
    {
     "id": "N20",
     "name": "Gas Heating Coil Parasitic Electric Load",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "A13",
     "name": "Heat Recovery Type",
     "type": "alpha",
     "keys": [
      "None",
      "Sensible",
      "Enthalpy"
     ],
     "default": "None"
    },
    {
     "id": "N21",
     "name": "Heat Recovery Sensible Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.70"
    },
    {
     "id": "N22",
     "name": "Heat Recovery Latent Effectiveness",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.65"
    },
    {
     "id": "A14",
     "name": "Heat Recovery Heat Exchanger Type",
     "type": "alpha",
     "keys": [
      "Plate",
      "Rotary"
     ],
     "default": "Plate"
    },
    {
     "id": "A15",
     "name": "Heat Recovery Frost Control Type",
     "type": "alpha",
     "keys": [
      "None",
      "ExhaustAirRecirculation",
      "ExhaustOnly",
      "MinimumExhaustTemperature"
     ],
     "default": "None"
    },
    {
     "id": "A16",
     "name": "Dehumidification Control Type",
     "type": "alpha",
     "keys": [
      "None",
      "CoolReheatHeatingCoil",
      "CoolReheatDesuperheater",
      "Multimode"
     ],
     "default": "None"
    },
    {
     "id": "N23",
     "name": "Dehumidification Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.00924",
     "units": "kgWater/kgDryAir"
    },
    {
     "id": "A17",
     "name": "Humidifier Type",
     "type": "alpha",
     "keys": [
      "None",
      "ElectricSteam"
     ],
     "default": "None"
    },
    {
     "id": "A18",
     "name": "Humidifier Availability Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N24",
     "name": "Humidifier Rated Capacity",
     "type": "numeric",
     "keys": [],
     "units": "m3/s",
     "min": 0,
     "minInclusive": true,
     "default": "0.000001"
    },
    {
     "id": "N25",
     "name": "Humidifier Rated Electric Power",
     "type": "numeric",
     "keys": [],
     "units": "W",
     "min": 0,
     "minInclusive": true,
     "autosizable": true,
     "default": "autosize"
    },
    {
     "id": "N26",
     "name": "Humidifier Constant Setpoint",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.003",
     "units": "kgWater/kgDryAir"
    },
    {
     "id": "A19",
     "name": "Dehumidification Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A20",
     "name": "Humidifier Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    }
   ]
  },
  "HVACTemplate:Plant:ChilledWaterLoop": {
   "minFields": 21,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true
    },
    {
     "id": "A2",
     "name": "Pump Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A3",
     "name": "Pump Control Type",
     "type": "alpha",
     "keys": [
      "Intermittent",
      "Continuous"
     ],
     "default": "Intermittent"
    },
    {
     "id": "A4",
     "name": "Chiller Plant Operation Scheme Type",
     "type": "alpha",
     "keys": [
      "Default",
      "UserDefined"
     ],
     "default": "Default"
    },
    {
     "id": "A5",
     "name": "Chiller Plant Equipment Operation Schemes Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "PlantOperationSchemes"
     ]
    },
    {
     "id": "A6",
     "name": "Chilled Water Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N1",
     "name": "Chilled Water Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "7.22",
     "units": "C"
    },
    {
     "id": "A7",
     "name": "Chilled Water Pump Configuration",
     "type": "alpha",
     "keys": [
      "ConstantPrimaryNoSecondary",
      "VariablePrimaryNoSecondary",
      "ConstantPrimaryVariableSecondary"
     ],
     "default": "ConstantPrimaryNoSecondary"
    },
    {
     "id": "N2",
     "name": "Primary Chilled Water Pump Rated Head",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "179352"
    },
    {
     "id": "N3",
     "name": "Secondary Chilled Water Pump Rated Head",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "179352"
    },
    {
     "id": "A8",
     "name": "Condenser Plant Operation Scheme Type",
     "type": "alpha",
     "keys": [
      "Default",
      "UserDefined"
     ],
     "default": "Default"
    },
    {
     "id": "A9",
     "name": "Condenser Equipment Operation Schemes Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "CondenserOperationSchemes"
     ]
    },
    {
     "id": "A10",
     "name": "Condenser Water Temperature Control Type",
     "type": "alpha",
     "keys": [
      "OutdoorWetBulbTemperature",
      "SpecifiedSetpoint"
     ]
    },
    {
     "id": "A11",
     "name": "Condenser Water Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N4",
     "name": "Condenser Water Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "29.4",
     "units": "C"
    },
    {
     "id": "N5",
     "name": "Condenser Water Pump Rated Head",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "179352"
    },
    {
     "id": "A12",
     "name": "Chilled Water Setpoint Reset Type",
     "type": "alpha",
     "keys": [
      "None",
      "OutdoorAirTemperatureReset"
     ],
     "default": "None"
    },
    {
     "id": "N6",
     "name": "Chilled Water Setpoint at Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "12.2"
    },
    {
     "id": "N7",
     "name": "Chilled Water Reset Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "15.6"
    },
    {
     "id": "N8",
     "name": "Chilled Water Setpoint at Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "6.7"
    },
    {
     "id": "N9",
     "name": "Chilled Water Reset Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "26.7"
    },
    {
     "id": "A13",
     "name": "Chilled Water Primary Pump Type",
     "type": "alpha",
     "keys": [
      "SinglePump",
      "PumpPerChiller",
      "TwoHeaderedPumps",
      "ThreeHeaderedPumps",
      "FourHeaderedPumps",
      "FiveHeaderedPumps"
     ],
     "default": "SinglePump"
    },
    {
     "id": "A14",
     "name": "Chilled Water Secondary Pump Type",
     "type": "alpha",
     "keys": [
      "SinglePump",
      "TwoHeaderedPumps",
      "ThreeHeaderedPumps",
      "FourHeaderedPumps",
      "FiveHeaderedPumps"
     ],
     "default": "SinglePump"
    },
    {
     "id": "A15",
     "name": "Condenser Water Pump Type",
     "type": "alpha",
     "keys": [
      "SinglePump",
      "PumpPerTower",
      "TwoHeaderedPumps",
      "ThreeHeaderedPumps",
      "FourHeaderedPumps",
      "FiveHeaderedPumps"
     ],
     "default": "SinglePump"
    },
    {
     "id": "A16",
     "name": "Chilled Water Supply Side Bypass Pipe",
     "type": "alpha",
     "keys": [
      "Yes",
      "No"
     ],
     "default": "Yes"
    },
    {
     "id": "A17",
     "name": "Chilled Water Demand Side Bypass Pipe",
     "type": "alpha",
     "keys": [
      "Yes",
      "No"
     ],
     "default": "Yes"
    },
    {
     "id": "A18",
     "name": "Condenser Water Supply Side Bypass Pipe",
     "type": "alpha",
     "keys": [
      "Yes",
      "No"
     ],
     "default": "Yes"
    },
    {
     "id": "A19",
     "name": "Condenser Water Demand Side Bypass Pipe",
     "type": "alpha",
     "keys": [
      "Yes",
      "No"
     ],
     "default": "Yes"
    },
    {
     "id": "A20",
     "name": "Fluid Type",
     "type": "alpha",
     "keys": [
      "Water",
      "EthyleneGlycol30",
      "EthyleneGlycol40",
      "EthyleneGlycol50",
      "EthyleneGlycol60",
      "PropyleneGlycol30",
      "PropyleneGlycol40",
      "PropyleneGlycol50",
      "PropyleneGlycol60"
     ],
     "default": "Water"
    },
    {
     "id": "N10",
     "name": "Loop Design Delta Temperature",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "6.67"
    },
    {
     "id": "N11",
     "name": "Minimum Outdoor Dry Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "A21",
     "name": "Chilled Water Load Distribution Scheme",
     "type": "alpha",
     "keys": [
      "Optimal",
      "SequentialLoad",
      "UniformLoad",
      "UniformPLR",
      "SequentialUniformPLR"
     ],
     "default": "SequentialLoad"
    },
    {
     "id": "A22",
     "name": "Condenser Water Load Distribution Scheme",
     "type": "alpha",
     "keys": [
      "Optimal",
      "SequentialLoad",
      "UniformLoad",
      "UniformPLR",
      "SequentialUniformPLR"
     ],
     "default": "SequentialLoad"
    }
   ]
  },
  "HVACTemplate:Plant:Chiller": {
   "minFields": 7,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true
    },
    {
     "id": "A2",
     "name": "Chiller Type",
     "type": "alpha",
     "keys": [
      "DistrictChilledWater",
      "ElectricCentrifugalChiller",
      "ElectricScrewChiller",
      "ElectricReciprocatingChiller"
     ],
     "required": true
    },
    {
     "id": "N1",
     "name": "Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "N2",
     "name": "Nominal COP",
     "type": "numeric",
     "keys": [],
     "required": true,
     "units": "W/W",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "A3",
     "name": "Condenser Type",
     "type": "alpha",
     "keys": [
      "AirCooled",
      "WaterCooled",
      "EvaporativelyCooled"
     ],
     "default": "WaterCooled"
    },
    {
     "id": "A4",
     "name": "Priority",
     "type": "alpha",
     "keys": []
    },
    {
     "id": "N3",
     "name": "Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "default": "1.0"
    },
    {
     "id": "N4",
     "name": "Minimum Part Load Ratio",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "N5",
     "name": "Maximum Part Load Ratio",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "default": "1.0"
    },
    {
     "id": "N6",
     "name": "Optimum Part Load Ratio",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "default": "1.0"
    },
    {
     "id": "N7",
     "name": "Minimum Unloading Ratio",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "default": "0.25"
    },
    {
     "id": "N8",
     "name": "Leaving Chilled Water Lower Temperature Limit",
     "type": "numeric",
     "keys": [],
     "default": "5.0",
     "units": "C"
    }
   ]
  },
  "HVACTemplate:Plant:Tower": {
   "minFields": 9,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true
    },
    {
     "id": "A2",
     "name": "Tower Type",
     "type": "alpha",
     "keys": [
      "SingleSpeed",
      "TwoSpeed"
     ],
     "required": true
    },
    {
     "id": "N1",
     "name": "High Speed Nominal Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "N2",
     "name": "High Speed Fan Power",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "N3",
     "name": "Low Speed Nominal Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "N4",
     "name": "Low Speed Fan Power",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "N5",
     "name": "Free Convection Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W",
     "min": 0,
     "minInclusive": true
    },
    {
     "id": "A3",
     "name": "Priority",
     "type": "alpha",
     "keys": []
    },
    {
     "id": "N6",
     "name": "Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "default": "1.0"
    },
    {
     "id": "A4",
     "name": "Template Plant Loop Type",
     "type": "alpha",
     "keys": [
      "ChilledWater",
      "MixedWater"
     ]
    }
   ]
  },
  "HVACTemplate:Plant:HotWaterLoop": {
   "minFields": 14,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true
    },
    {
     "id": "A2",
     "name": "Pump Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "A3",
     "name": "Pump Control Type",
     "type": "alpha",
     "keys": [
      "Intermittent",
      "Continuous"
     ],
     "default": "Intermittent"
    },
    {
     "id": "A4",
     "name": "Hot Water Plant Operation Scheme Type",
     "type": "alpha",
     "keys": [
      "Default",
      "UserDefined"
     ],
     "default": "Default"
    },
    {
     "id": "A5",
     "name": "Hot Water Plant Equipment Operation Schemes Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "PlantOperationSchemes"
     ]
    },
    {
     "id": "A6",
     "name": "Hot Water Setpoint Schedule Name",
     "type": "alpha",
     "keys": [],
     "objectList": [
      "ScheduleNames"
     ]
    },
    {
     "id": "N1",
     "name": "Hot Water Design Setpoint",
     "type": "numeric",
     "keys": [],
     "default": "82.0",
     "units": "C"
    },
    {
     "id": "A7",
     "name": "Hot Water Pump Configuration",
     "type": "alpha",
     "keys": [
      "VariableFlow",
      "ConstantFlow"
     ],
     "default": "ConstantFlow"
    },
    {
     "id": "N2",
     "name": "Hot Water Pump Rated Head",
     "type": "numeric",
     "keys": [],
     "units": "Pa",
     "min": 0,
     "minInclusive": true,
     "default": "179352"
    },
    {
     "id": "A8",
     "name": "Hot Water Setpoint Reset Type",
     "type": "alpha",
     "keys": [
      "None",
      "OutdoorAirTemperatureReset"
     ],
     "default": "None"
    },
    {
     "id": "N3",
     "name": "Hot Water Setpoint at Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "82.2"
    },
    {
     "id": "N4",
     "name": "Hot Water Reset Outdoor Dry-Bulb Low",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "-6.7"
    },
    {
     "id": "N5",
     "name": "Hot Water Setpoint at Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "65.6"
    },
    {
     "id": "N6",
     "name": "Hot Water Reset Outdoor Dry-Bulb High",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "10.0"
    },
    {
     "id": "A9",
     "name": "Hot Water Pump Type",
     "type": "alpha",
     "keys": [
      "SinglePump",
      "PumpPerBoiler",
      "TwoHeaderedPumps",
      "ThreeHeaderedPumps",
      "FourHeaderedPumps",
      "FiveHeaderedPumps"
     ],
     "default": "SinglePump"
    },
    {
     "id": "A10",
     "name": "Supply Side Bypass Pipe",
     "type": "alpha",
     "keys": [
      "Yes",
      "No"
     ],
     "default": "Yes"
    },
    {
     "id": "A11",
     "name": "Demand Side Bypass Pipe",
     "type": "alpha",
     "keys": [
      "Yes",
      "No"
     ],
     "default": "Yes"
    },
    {
     "id": "A12",
     "name": "Fluid Type",
     "type": "alpha",
     "keys": [
      "Water",
      "EthyleneGlycol30",
      "EthyleneGlycol40",
      "EthyleneGlycol50",
      "EthyleneGlycol60",
      "PropyleneGlycol30",
      "PropyleneGlycol40",
      "PropyleneGlycol50",
      "PropyleneGlycol60"
     ],
     "default": "Water"
    },
    {
     "id": "N7",
     "name": "Loop Design Delta Temperature",
     "type": "numeric",
     "keys": [],
     "units": "deltaC",
     "default": "11.0"
    },
    {
     "id": "N8",
     "name": "Maximum Outdoor Dry Bulb Temperature",
     "type": "numeric",
     "keys": [],
     "units": "C"
    },
    {
     "id": "A13",
     "name": "Load Distribution Scheme",
     "type": "alpha",
     "keys": [
      "Optimal",
      "SequentialLoad",
      "UniformLoad",
      "UniformPLR",
      "SequentialUniformPLR"
     ],
     "default": "SequentialLoad"
    }
   ]
  },
  "HVACTemplate:Plant:Boiler": {
   "minFields": 7,
   "fields": [
    {
     "id": "A1",
     "name": "Name",
     "type": "alpha",
     "keys": [],
     "required": true
    },
    {
     "id": "A2",
     "name": "Boiler Type",
     "type": "alpha",
     "keys": [
      "DistrictHotWater",
      "HotWaterBoiler",
      "CondensingHotWaterBoiler"
     ],
     "required": true
    },
    {
     "id": "N1",
     "name": "Capacity",
     "type": "numeric",
     "keys": [],
     "autosizable": true,
     "default": "autosize",
     "units": "W",
     "min": 0,
     "minInclusive": false
    },
    {
     "id": "N2",
     "name": "Efficiency",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "max": 1,
     "maxInclusive": true,
     "default": "0.8"
    },
    {
     "id": "A3",
     "name": "Fuel Type",
     "type": "alpha",
     "keys": [
      "Electricity",
      "NaturalGas",
      "Propane",
      "FuelOilNo1",
      "FuelOilNo2",
      "Coal",
      "Diesel",
      "Gasoline",
      "OtherFuel1",
      "OtherFuel2"
     ]
    },
    {
     "id": "A4",
     "name": "Priority",
     "type": "alpha",
     "keys": []
    },
    {
     "id": "N3",
     "name": "Sizing Factor",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": false,
     "default": "1.0"
    },
    {
     "id": "N4",
     "name": "Minimum Part Load Ratio",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "default": "0.0"
    },
    {
     "id": "N5",
     "name": "Maximum Part Load Ratio",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "default": "1.1"
    },
    {
     "id": "N6",
     "name": "Optimum Part Load Ratio",
     "type": "numeric",
     "keys": [],
     "min": 0,
     "minInclusive": true,
     "default": "1.0"
    },
    {
     "id": "N7",
     "name": "Water Outlet Upper Temperature Limit",
     "type": "numeric",
     "keys": [],
     "units": "C",
     "default": "100.0"
    },
    {
     "id": "A5",
     "name": "Template Plant Loop Type",
     "type": "alpha",
     "keys": [
      "HotWater",
      "MixedWater"
     ]
    }
   ]
  }
 }
}